import ProjectStatus from "$lib/components/ProjectStatus.svelte";
import DateDisplay from "$lib/components/ui/DateDisplay.svelte";
import OpenButton from "$lib/components/ui/OpenButton.svelte";

export let projectsHeader = [
    {
        property: 'customer.registry',
        label: 'KdNr',
        sortable: true,
        movable: true,
        class: 'w-20',
        render: row => row.customer.registry,
        customSort: (a, b, c) => a.customer.registry < b.customer.registry ? c : -1*c
    },
    {
        property: 'associate.lastName',
        label: 'Besteller',
        sortable: true,
        movable: true,
        class: 'w-38',
        render: row => row.responsibleAssociate?.firstName + ' ' + row.responsibleAssociate?.lastName,
        //render: row => '<span class="font-bo,ld">' + row.responsibleUser?.associations?.find(x => x.customerId === row.customerId)?.name + '</span>',
        //customSort: (a, b, c) => a.responsibleUser?.associations.find(x => x.customerId === a.customerId)?.name < b.responsibleUser?.associations.find(x => x.customerId === b.customerId)?.name ? c : -1*c
    },
    {
        property: 'customerId',
        label: 'Kunde',
        movable: true,
        sortable: true,
        render: row => row.customer.name
    },
    {
        label: 'Titel',
        property: 'name',
        sortable: true,
        movable: true,
    },
    {
        label: 'Status',
        property: 'status',
        component: ProjectStatus,
        sortable: true,
        movable: true,
    },
    {
        label: 'Beginn',
        property: 'startsAt',
        component: DateDisplay,
        sortable: true,
        movable: true,
    },
    {
        label: 'Öffnen',
        property: 'uuid',
        component: OpenButton,
        props: {
            onClick: uuid => location.href = '/project/' + uuid
        },
        class: 'w-16',
        movable: false,
    },
]